const userApps = {
  userApps: 'Aplicaciones de administrador',
  showing: 'mostrando',
  userAppsOf: 'aplicaciones de',
  noUserAppsFound: 'No se encontraron aplicaciones de usuario',
};

export default userApps;
